// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.shopcard-container[data-v-a5f21b30] {\n  display: flex;\n  flex-direction: column;\n  gap: 1em\n}\n.shopcard[data-v-a5f21b30] {\n  display: flex;\n  flex-direction: column;\n  gap: 1em;\n}\n.store-registration-buttons[data-v-a5f21b30] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1em;\n}\n", ""]);
// Exports
module.exports = exports;
